var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counselor-base",class:{ vt1: _vm.viewType === 1 }},[_c('div',{staticClass:"face"},[(_vm.cImageUrlMod)?_c('img',{attrs:{"src":_vm.cImageUrlMod}}):_c('span',{staticClass:"noimage"},[_vm._v("noimage")])]),_vm._v(" "),_c('div',{staticClass:"c-name"},[_vm._v(_vm._s(_vm.cName))]),_vm._v(" "),_c('div',{staticClass:"c-profile"},[_vm._v(_vm._s(_vm.cProf))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3870b1ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/YearLuck/y2020/partials/counselor.vue
// module id = null
// module chunks = 